import React from 'react';
import {
  Button,
  Colors,
  ControlGroup,
  InputGroup,
  Icon,
  Intent,
  Position,
  Toaster
} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import config from '../../../../../../config';
import {typePathMap} from '../../../../../utils/typePathMap';

interface CopyLink {
  uid: string;
  type?: string; // report type: default, notebook, embed
}

const copyMessage = Toaster.create({
  className: 'copy-message',
  position: Position.TOP
});

const onCopy = () => {
  copyMessage.show({
    message: "Link has been copied to clipboard!",
    intent: Intent.SUCCESS
  });
};

const NOTE: string = 'Only people with access to the report can open the link.';

const CopyLink = ({
  uid,
  type,
}: CopyLink) => {
  let path = typePathMap(type);
  let url = uid ? `${config.app.url}/r/${path}edit/${uid}` : '';

  return (
    <div className="share-report__popover__copy-link">
      <p><Icon icon={IconNames.LINK} color={Colors.GRAY1}/> Copy link:</p>
      <ControlGroup>
        <InputGroup
          className="copy-link"
          disabled={true}
          defaultValue={url}
          fill={true}/>
        <CopyToClipboard text={url} onCopy={onCopy}>
          <Button icon={IconNames.DUPLICATE}/>
        </CopyToClipboard>
      </ControlGroup>
      <span>{NOTE}</span>
    </div>
  );
}

export default CopyLink;
